import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AppTranslateModule } from '@core/app-translate.module';
import { FormErrorModule } from '@feature/forms/form-error/form-error.module';
import { FormFileInputModule } from '@feature/forms/form-file-input/form-file-input.module';

import { FormFileComponent } from './form-file.component';
import { MatFormFieldModule } from '@angular/material/form-field';

export const imports: NgModule['imports'] = [
  FormErrorModule,
  MatFormFieldModule,
  FormFileInputModule,
  ReactiveFormsModule,
];

@NgModule({
  declarations: [FormFileComponent],
  imports: [...imports, CommonModule, AppTranslateModule],
  exports: [FormFileComponent],
})
export class FormFileModule {}
